import { render, staticRenderFns } from "./shopWithdraw.vue?vue&type=template&id=4072ce20&"
import script from "./shopWithdraw.vue?vue&type=script&lang=js&"
export * from "./shopWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./shopWithdraw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports